module.exports = {
  fetch: `query getAssignments($caseId: String) {
    assignments(filter: {
      caseId: { eq: $caseId }
    }) {
      id
      caseId
      name
      caseName
      attemptsCount
      additionalAttempts {
        principalType
        principalId
        count
      }
      startTime
      endTime
      emailParticipants
      status
      students {
        groups
        users
        roles
      }
      access {
        owner
        ownerOrg
        read {
          groups
          users
          roles
        }
        write {
          groups
          users
          roles
        }
        run {
          groups
          users
          roles
        }
        share {
          groups
          users
          roles
        }
      }
    }
  }`,
  fetchById: `query getAssignments($id: ID) {
    assignments(id: $id) {
      id
      caseId
      name
      caseName
      attemptsCount
      additionalAttempts {
        principalType
        principalId
        count
      }
      startTime
      endTime
      emailParticipants
      status
      students {
        groups
        users
        roles
      }
      access {
        owner
        ownerOrg
        read {
          groups
          users
          roles
        }
        write {
          groups
          users
          roles
        }
        run {
          groups
          users
          roles
        }
        share {
          groups
          users
          roles
        }
      }
    }
  }`,
  save: `mutation saveAssignment($value: AssignmentInput) {
    upsertAssignment(assignment: $value) {
      id
      name
      startTime
      endTime
      emailParticipants
      status
    }
  }
  `,
  remove: `
    mutation removeAssignments($ids: [ID]) {
      bulkRemoveAssignments(ids: $ids)
    }
  `,
};
